export default "__VITE_ASSET__d00cf13a__"